<ng-container *ngIf="model && model.view && (layoutMode !== 'gallery' || model.type === 'collection-header')">
  <div
    [id]="'result-item-' + resultsIndex"
    #element
    class="results-item"
    [class.blur]="confirmOptions"
    [class.clickable]="isClickable"
    tabindex="-1"
    [dragAndDrop]="dragData"
    data-cy="search-results-item"
  >
    <div
      class="result-item-content-container"
      [ngClass]="{
        'favorite-container': showResultSections.showFavoriteAction,
        'has-preview-indicate': isPreviewClickAction(model?.action) && !disablePreviewIcon && showResultSections.showPreviewIcon,
        'has-summary-indicate': isAvailableSummary(model?.action),
      }"
    >
      <div class="search-results-icon" data-cy="search-results-icon">
        <u-icon
          *ngIf="model.view?.icon"
          class="result-icon-logo no-drag"
          (error)="onIconError($event)"
          [model]="iconModel"
          [inSvg]="iconModel.value?.lightUrl"
        ></u-icon>
        <u-icon
          *ngIf="model.view?.iconOverlay"
          iconCtx="style"
          class="result-icon-overlay no-drag"
          [model]="iconOverlayModel"
          [styles]="{ backgroundSize: 'contain' }"
        ></u-icon>
      </div>
      <div class="main" [class.one-line]="isShowSingleLineView" #main>
        <ng-container *ngIf="model.showResultSections.showInputTitle || showResultSections.showInputTitle">
          <input-title
            [text]="model.view.title.text"
            [inputPlaceholder]="inputPlaceholder"
            [defaultInputModel]="defaultInputModel"
            [inputModel]="model.view.title.text"
            [fontSize]="model.type === 'collection-header' ? 'large' : 'regular'"
            (onDisplayInput)="onDisplayInput($event)"
            (onBlurUInput)="onBlurUInput($event)"
            (outsideClick)="onEditTitleClickOut()"
          >
          </input-title>
        </ng-container>
        <div
          class="title-container"
          [class.one-line]="isShowSingleLineView"
          [class.collection-header]="model.type === 'collection-header'"
          *ngIf="model.view && !model.showResultSections.showInputTitle && !showResultSections.showInputTitle"
          [class.with-subtitle]="model.view.subtitle && !showResultSections.showSubtitleInSecondLine && !isShowSingleLineView"
          [class.with-badge]="model.view.badge"
          [class.trim-content]="
            !isLauncher &&
            !isShowSingleLineView &&
            model.view.subtitle &&
            showResultSections.trimSubtitleLength &&
            !showResultSections.showSubtitleInSecondLine
          "
        >
          <div class="title-text">
            <result-title
              [model]="model.action?.type === 'files' ? fileItemTitle?.start : model.view.title"
              [class.light]="lightTitle"
              [highlights]="model.highlights"
              [mainWidth]="mainWidth"
              [showSingleLineView]="isShowSingleLineView || !model.view.subtitle || showResultSections.showSubtitleInSecondLine"
              (contextmenu)="onRightClick($event, 'title')"
              (auxclick)="onAuxClick($event, 'title')"
              (invoke)="
                onInvoke({
                  command: $event.command,
                  context: makeContext({ appId: model?.resource?.appId, openWith: model.openWith }, $event.context),
                  trigger: $event.trigger,
                  source: $event.source,
                  immediate: $event.immediate,
                })
              "
              [selected]="selected"
              [dragMetadata]="dragMetadata"
              (click)="onTitleClick()"
              click-invoker
              #title
            >
              <span *ngIf="model.action?.type === 'files'"> {{ fileItemTitle?.end }}</span>
            </result-title>

            <ng-container *ngTemplateOutlet="!isShowSingleLineView && !showResultSections.showSubtitleInSecondLine ? resultSubtitle : null">
            </ng-container>
          </div>

          <div class="title-indicate">
            <ng-container *ngTemplateOutlet="!isShowSingleLineView ? resultBadge : null"> </ng-container>
            <ng-container *ngTemplateOutlet="!isShowSingleLineView ? resultFavorite : null"> </ng-container>
          </div>
        </div>

        <ng-container *ngTemplateOutlet="isShowSingleLineView || showResultSections.showSubtitleInSecondLine ? resultSubtitle : null">
        </ng-container>
        <ng-container *ngTemplateOutlet="isShowSingleLineView ? resultBadge : null"> </ng-container>
        <ng-container *ngTemplateOutlet="isShowSingleLineView ? resultFavorite : null"> </ng-container>

        <ng-container *ngIf="model.view.subView && showResultSections.showSubView">
          <result-sub-view [model]="model.view.subView" [highlights]="model.highlights" (invoke)="onInvoke($event)"></result-sub-view>
        </ng-container>

        <div
          #resultBullets
          class="bullets-container result-line"
          tabindex="-1"
          *ngIf="model.view?.bullets?.length > 0 && showResultSections.showBullets"
        >
          <result-bullet
            #resultBullet
            tabindex="-1"
            *ngFor="let bullet of model.view.bullets | slice: 0 : bulletsLimit; index as i"
            [model]="bullet"
            [maxBulletWidth]="maxBulletWidth(i, bulletPartsRef)"
            click-invoker
            [fallback]="fallbackIcon?.lightUrl"
            [ngStyle]="i === bulletsLimit - 1 ? { 'max-width': lastChildWidth + 'px' } : { 'max-width': '100%' }"
            (invoke)="onInvoke({ command: $event, trigger: 'mouse_click' })"
          >
          </result-bullet>
          <result-bullet
            class="hidden-bullets-counetr"
            *ngIf="model?.view?.bullets?.length - bulletsLimit > 0"
            tabindex="-1"
            [model]="counterBullet"
            click-invoker
            (invoke)="onInvoke({ command: $event, trigger: 'mouse_click' })"
          ></result-bullet>
        </div>
      </div>
    </div>
    <restricted-message *ngIf="restrictedLink" [ngClass]="{ hidden: !selected }"></restricted-message>
    <div class="buttons-container" [ngClass]="{ hide: !selected }" *ngIf="showResultSections?.showContextMenu">
      <ng-container *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG">
        <div
          class="favorite-star"
          click-invoker
          (click)="toggleFavoriteAction('mouse_click')"
          *ngIf="showResultSections.showFavoriteAction"
        >
          <u-icon
            pTooltip="Remove from favorites"
            tooltipPosition="top"
            tooltipStyleClass="u-tooltip"
            [styles]="{ color: 'var(--color-primary)', fontSize: '14px' }"
            [model]="{ type: 'font', value: 'icon-star-solid' }"
          ></u-icon>
        </div>
      </ng-container>

      <u-icon
        *ngIf="isPreviewClickAction(model?.action) && !disablePreviewIcon && showResultSections.showPreviewIcon"
        (click)="onPreviewClick(); $event.stopPropagation()"
        class="indicate-preview"
        [model]="INDICATE_PREVIEW_ICON"
        pTooltip="Preview"
        tooltipPosition="top"
        tooltipStyleClass="u-tooltip"
      ></u-icon>
      <u-icon
        *ngIf="isAvailableSummary(model?.action) && showResultSections.showSummaryIcon"
        class="indicate-summary"
        (click)="onSummary($event); $event.stopPropagation()"
        [model]="INDICATE_SUMMARY_ICON"
        pTooltip="Show summary"
        tooltipPosition="top"
        tooltipStyleClass="u-tooltip"
      ></u-icon>
      <square-button
        [active]="contextMenuHelper?.source === 'actions'"
        click-invoker
        (click)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        (auxclick)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        (contextmenu)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        #actions
        >•••</square-button
      >
      <new-indication *ngIf="showResultSections?.showNewIndication" [tooltip]="showResultSections.showNewIndication"></new-indication>
    </div>
  </div>

  <div class="blocker" *ngIf="model.deleted"></div>
  <div class="confirm" *ngIf="confirmOptions" (click)="onConfirm(null, $event)">
    <span class="message" *ngIf="confirmOptions.message !== null">{{ confirmOptions.message || 'Are you sure?' }}</span>
    <button class="cancel-btn" (click)="onConfirm(false, $event)">
      <i class="far fa-times-circle"></i>{{ confirmOptions.cancelText || 'No' }}
    </button>
    <button class="confirm-btn" (click)="onConfirm(true, $event)">
      <i class="far fa-check-circle"></i>{{ confirmOptions.confirmText || 'Yes' }}
    </button>
  </div>
</ng-container>

<ng-template #resultFavorite>
  <ng-container *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG">
    <div
      class="favorite"
      click-invoker
      *ngIf="
        model.isFavorite &&
        hubService.currentLocation !== 'favorites' &&
        !showResultSections.showFavoriteAction &&
        showResultSections.showFavoriteIcon !== false
      "
    >
      <u-icon [model]="{ type: 'font', value: 'icon-star-solid' }"></u-icon>
    </div>
  </ng-container>
</ng-template>

<ng-container *ngIf="layoutMode === 'gallery' && model.type !== 'collection-header'">
  <gallery-view
    [model]="model"
    [settings]="{
      showPreview: isPreviewClickAction(model?.action) && !disablePreviewIcon && showResultSections.showPreviewIcon,
      showSummary: isAvailableSummary(model?.action) && showResultSections.showSummaryIcon,
      showCheckbox: showResultSections.isEditable,
      showDrag: showResultSections.isDraggable,
      showInputTitle: model.showResultSections.showInputTitle || showResultSections.showInputTitle,
      showFavorite:
        model.isFavorite &&
        hubService.currentLocation !== 'favorites' &&
        !showResultSections.showFavoriteAction &&
        showResultSections.showFavoriteIcon !== false,
      showNewIndication: showResultSections?.showNewIndication,
    }"
    [thumbnail]="thumbnail"
    [inputPlaceholder]="inputPlaceholder"
    [contextMenuActive]="contextMenuHelper?.source === 'actions'"
    (invoke)="galleryInvoke($event)"
    [checked]="checked"
    [selected]="selected"
  >
    <ng-template let-value pTemplate="dragItem">
      <ng-content select=".drag-ind"></ng-content>
    </ng-template>
  </gallery-view>
</ng-container>
